// src/pages/Admin/PagesPersonnalisees/PageList.jsx
import React from "react";
import ButtonEdit from "./../../../components/Button/ButtonEdit";
import ButtonDelete from "./../../../components/Button/ButtonDelete";
import Button from "./../../../components/Button/Button";

const PageList = ({ pages = [], onEdit, onDelete, onManageArticles }) => {
  if (!pages.length) {
    return (
      <div className="text-center py-10">
        <p className="text-sm text-slate-600 dark:text-slate-400">
          Aucune page à afficher.
        </p>
      </div>
    );
  }

  return (
    <div className="w-full">
      {/* TABLE (desktop) */}
      <div className="hidden md:block">
        <div className="overflow-x-auto rounded-xl">
          <table className="min-w-full table-fixed">
            <thead>
              <tr className="bg-slate-50/80 dark:bg-slate-900/80 uppercase tracking-wide text-xs">
                <th className="px-4 py-3 text-left font-semibold text-slate-700 dark:text-white w-[36%]">
                  Titre
                </th>
                <th className="px-4 py-3 text-left font-semibold text-slate-700 dark:text-white w-[30%]">
                  Chemin
                </th>
                <th className="px-4 py-3 text-left font-semibold text-slate-700 dark:text-white w-[14%]">
                  Statut
                </th>
                <th className="px-4 py-3 text-left font-semibold text-slate-700 dark:text-white w-[20%]">
                  Actions
                </th>
              </tr>
            </thead>

            <tbody className="divide-y divide-slate-100 dark:divide-slate-800 text-sm">
              {pages.map((page) => {
                const title = page.title ?? page.titre ?? "Sans titre";
                const slug = page.slug ? `/${page.slug}` : "—";
                const isActive = Boolean(page.is_active ?? page.actif);

                return (
                  <tr
                    key={page.id}
                    className="group transition-colors hover:bg-slate-50/70 dark:hover:bg-slate-800/40"
                  >
                    <td className="px-4 py-3 font-medium text-slate-900 dark:text-slate-100">
                      {title}
                    </td>
                    <td className="px-4 py-3">
                      <span className="inline-flex items-center rounded-md border border-slate-200 dark:border-slate-700 bg-white/70 dark:bg-slate-900/40 px-2 py-0.5 text-sm text-slate-800 dark:text-slate-100">
                        {slug}
                      </span>
                    </td>
                    <td className="px-4 py-3">
                      <span
                        className={`inline-flex items-center rounded-full px-2 py-0.5 text-xs font-semibold ${
                          isActive
                            ? "bg-emerald-100 text-emerald-800 dark:bg-emerald-900/40 dark:text-emerald-200"
                            : "bg-slate-100 text-slate-700 dark:bg-slate-800/60 dark:text-slate-300"
                        }`}
                      >
                        {isActive ? "Actif" : "Inactif"}
                      </span>
                    </td>
                    <td className="px-4 py-3">
                      <div className="flex flex-wrap items-center gap-2">
                        <ButtonEdit onClick={() => onEdit?.(page)} />
                        <ButtonDelete onClick={() => onDelete?.(page.id)} />
                        {onManageArticles && (
                          <Button
                            text="Gérer articles"
                            onClick={() => onManageArticles?.(page)}
                            className="!rounded-lg !px-3 !py-1.5 !text-xs"
                          />
                        )}
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>

      {/* CARDS (mobile) */}
      <div className="md:hidden space-y-3">
        {pages.map((page) => {
          const title = page.title ?? page.titre ?? "Sans titre";
          const slug = page.slug ? `/${page.slug}` : "—";
          const isActive = Boolean(page.is_active ?? page.actif);

          return (
            <div
              key={`card-${page.id}`}
              className="rounded-xl border border-slate-200 dark:border-slate-800 bg-white/90 dark:bg-slate-900/40 p-4 shadow-sm transition hover:shadow-md"
            >
              <div className="flex items-start justify-between gap-3">
                <div className="min-w-0">
                  <h3 className="text-base font-semibold text-slate-900 dark:text-slate-100 truncate">
                    {title}
                  </h3>
                  <p className="mt-1 text-xs">
                    <span className="inline-flex items-center rounded-md border border-slate-200 dark:border-slate-700 bg-white/70 dark:bg-slate-900/40 px-2 py-0.5 text-slate-800 dark:text-slate-100">
                      {slug}
                    </span>
                  </p>
                </div>
                <span
                  className={`shrink-0 inline-flex items-center rounded-full px-2 py-0.5 text-[11px] font-semibold ${
                    isActive
                      ? "bg-emerald-100 text-emerald-800 dark:bg-emerald-900/40 dark:text-emerald-200"
                      : "bg-slate-100 text-slate-700 dark:bg-slate-800/60 dark:text-slate-300"
                  }`}
                >
                  {isActive ? "Actif" : "Inactif"}
                </span>
              </div>

              <div className="mt-3 flex items-center gap-2">
                <ButtonEdit onClick={() => onEdit?.(page)} />
                <ButtonDelete onClick={() => onDelete?.(page.id)} />
                {onManageArticles && (
                  <Button
                    text="Gérer articles"
                    onClick={() => onManageArticles?.(page)}
                    className="!rounded-lg !px-3 !py-1.5 !text-xs"
                  />
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default PageList;
